import { useEffect, useState } from "react";
import { getOfertas } from "../../services/OfertasServices";
import { OfertasContext } from "./OfertasContext"


export const OfertasState = ({ children }) => {
    const [data, setData] = useState()

    useEffect(() => {
        getOfertasData()
    }, [])


    const getOfertasData = async () => {
        const clienteSelected = JSON.parse(localStorage.getItem('clienteSelected'));
        let res = await getOfertas(clienteSelected?.id)
        if (res) setData(res)
    }



    return <OfertasContext.Provider value={{
        data,
        getOfertasData
    }} >
        {children}
    </OfertasContext.Provider>
}